'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime from "./presto.types$-Limited-Local-Time.js";
var $p;
/** @constructor */
function $c_Lpresto_types$LimitedLocalTime$$anon$78(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$LimitedLocalTime$$anon$78 as $c_Lpresto_types$LimitedLocalTime$$anon$78 };
$p = $c_Lpresto_types$LimitedLocalTime$$anon$78.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$LimitedLocalTime$$anon$78;
/** @constructor */
function $h_Lpresto_types$LimitedLocalTime$$anon$78() {
}
export { $h_Lpresto_types$LimitedLocalTime$$anon$78 as $h_Lpresto_types$LimitedLocalTime$$anon$78 };
$h_Lpresto_types$LimitedLocalTime$$anon$78.prototype = $p;
$p.bN = (function(text) {
  return $m_Lpresto_types$LimitedLocalTime$().cLZ(text);
});
$p.cAR = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(((("" + it.or) + ":") + ("" + it.qg)));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bJ = (function(t) {
  return this.cAR(t);
});
var $d_Lpresto_types$LimitedLocalTime$$anon$78 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$LimitedLocalTime$$anon$78, "presto.types$LimitedLocalTime$$anon$78", ({
  a0z: 1,
  K: 1
}));
export { $d_Lpresto_types$LimitedLocalTime$$anon$78 as $d_Lpresto_types$LimitedLocalTime$$anon$78 };
function $p_Lpresto_types$LimitedLocalTime$__split$1__T__s_util_Try($thiz, str$12) {
  var x360 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__split__T__I__AT(str$12, ":", 0);
  if ((x360 !== null)) {
    if (($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Array$UnapplySeqWrapper$().T9(x360, 2) === 0)) {
      if ((x360.b[1].length === 2)) {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(x360);
      }
    }
  }
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Bad format '" + str$12) + "'")));
}
export { $p_Lpresto_types$LimitedLocalTime$__split$1__T__s_util_Try as $p_Lpresto_types$LimitedLocalTime$__split$1__T__s_util_Try };
function $p_Lpresto_types$LimitedLocalTime$__convert$1__T__F1__s_util_Try($thiz, str, fn) {
  try {
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_jl_Integer$().ij(str, 10));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.jQ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((v) => {
    var v$1 = (v | 0);
    return ((!(!fn.v(v$1))) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(v$1) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (("Bad range: '" + str) + "'"))));
  })));
}
export { $p_Lpresto_types$LimitedLocalTime$__convert$1__T__F1__s_util_Try as $p_Lpresto_types$LimitedLocalTime$__convert$1__T__F1__s_util_Try };
/** @constructor */
function $c_Lpresto_types$LimitedLocalTime$() {
  this.c7Z = null;
  this.c80 = false;
}
export { $c_Lpresto_types$LimitedLocalTime$ as $c_Lpresto_types$LimitedLocalTime$ };
$p = $c_Lpresto_types$LimitedLocalTime$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$LimitedLocalTime$;
/** @constructor */
function $h_Lpresto_types$LimitedLocalTime$() {
}
export { $h_Lpresto_types$LimitedLocalTime$ as $h_Lpresto_types$LimitedLocalTime$ };
$h_Lpresto_types$LimitedLocalTime$.prototype = $p;
$p.cst = (function() {
  if ((!this.c80)) {
    this.c7Z = new $c_Lpresto_types$LimitedLocalTime$$anon$78(this);
    this.c80 = true;
  }
  return this.c7Z;
});
$p.cLZ = (function(str) {
  return $p_Lpresto_types$LimitedLocalTime$__split$1__T__s_util_Try(this, str).jQ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((parts) => $p_Lpresto_types$LimitedLocalTime$__convert$1__T__F1__s_util_Try(this, parts.b[0], new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((i) => {
    var i$1 = (i | 0);
    return ((i$1 >= 0) && (i$1 <= 23));
  }))).jQ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((parts$2) => ((hour) => {
    var hour$1 = (hour | 0);
    return $p_Lpresto_types$LimitedLocalTime$__convert$1__T__F1__s_util_Try(this, parts$2.b[1], new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((i$2) => {
      var i$3 = (i$2 | 0);
      return ((i$3 >= 0) && (i$3 <= 59));
    }))).cL(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((minute) => new $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime.$c_Lpresto_types$LimitedLocalTime(hour$1, (minute | 0)))));
  }))(parts))))));
});
$p.crr = (function(x$0) {
  return new $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime.$c_Lpresto_types$LimitedLocalTime((x$0.j(0) | 0), (x$0.j(1) | 0));
});
var $d_Lpresto_types$LimitedLocalTime$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$LimitedLocalTime$, "presto.types$LimitedLocalTime$", ({
  a0y: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$LimitedLocalTime$ as $d_Lpresto_types$LimitedLocalTime$ };
var $n_Lpresto_types$LimitedLocalTime$;
function $m_Lpresto_types$LimitedLocalTime$() {
  if ((!$n_Lpresto_types$LimitedLocalTime$)) {
    $n_Lpresto_types$LimitedLocalTime$ = new $c_Lpresto_types$LimitedLocalTime$();
  }
  return $n_Lpresto_types$LimitedLocalTime$;
}
export { $m_Lpresto_types$LimitedLocalTime$ as $m_Lpresto_types$LimitedLocalTime$ };
//# sourceMappingURL=presto.types$-Limited-Local-Time$.js.map
